// Pure logic for the phone version of the host trips board.

/**
 * Which stage opens first: new inquiries, then finished trips waiting to be
 * invoiced (count only the ones the host can act on), then a trip that is
 * running, then the rest in pipeline order.
 */
export function defaultStage(counts: Record<string, number>, order: string[]): string {
  if (counts.inquiry) return 'inquiry';
  if (counts.invoice) return 'invoice';
  if (counts.active) return 'active';
  return order.find((id) => counts[id]) ?? order[0];
}

/** Next stage after a horizontal swipe, or null when it wasn't a deliberate sideways swipe. */
export function swipeTarget(dx: number, dy: number, ids: string[], current: string): string | null {
  if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return null;
  const i = ids.indexOf(current) + (dx < 0 ? 1 : -1);
  return i < 0 || i >= ids.length ? null : ids[i];
}
